import { render, staticRenderFns } from "./AffinityWinRate.vue?vue&type=template&id=2d8545ed&scoped=true"
import script from "./AffinityWinRate.vue?vue&type=script&lang=js"
export * from "./AffinityWinRate.vue?vue&type=script&lang=js"
import style0 from "./AffinityWinRate.vue?vue&type=style&index=0&id=2d8545ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8545ed",
  null
  
)

export default component.exports